const closeIcon = document.createElement('button');
closeIcon.className = 'close-popup';
closeIcon.innerText = '×';

Array.from(document.querySelectorAll('.popup')).forEach((popup) => {
	const insertedCloseIcon = popup.querySelector('.container .wrapper').appendChild(closeIcon);
	insertedCloseIcon.addEventListener('click', (event) => {
		event.preventDefault();
		popup.classList.toggle('open');
	});

	popup.querySelector('.bg').addEventListener('click', () => {
		popup.classList.toggle('open');
	});
});


Array.from(document.querySelectorAll('.toggle-popup-window')).forEach((link) => {
	link.addEventListener('click', (event) => {
		event.preventDefault();

		// Get the popup target
		let popupID = link.getAttribute('href');

		// Remove the # from the ID
		popupID = popupID.replace('#', '');

		// Fetch the popup
		const popup = document.getElementById(popupID);

		// Toggle open class on the popup
		popup.classList.toggle('open');
	});
});
